import React, { useState, useEffect } from "react";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import ButtonOptionGroup from "../../component/ButtonOptions/ButtonOption";
import ProductComponent from "./component/ProductComponent";
import MultiTagInput from "../../component/MultiTagInput/MultiTagInput";
import { getToken } from "../../../../helpers/Jwt";
import DiscountComponent from "./component/DiscountComponent";
import FormatTransaction from "../../component/FormatTransaction/FormatTransaction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGears } from "@fortawesome/free-solid-svg-icons";
import ContactComponent from "../../component/Contact/Contact";
import InputOption from "../../component/InputOption/InputOption";

const EntrySales = () => {
  const { id, type } = useParams();
  const navigate = useNavigate();

  const [detailData, setDetailData] = useState(null);
  const [itemData, setItemData] = useState([]);

  const [initialValues, setInitialValues] = useState({
    type
  });

  const [typeSale, setTypeSale] = useState(type ?? "invoice");
  const [contactCustomer, setContactCustomer] = useState([]);
  const [termsPayment, setTermsPayment] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [cashbank, setCashBank] = useState([]);
  const [cashbankPayment, setCashBankPayment] = useState([]);

  const [deductionChecked, setDeductionChecked] = useState(false);
  const [deductionAccount, setDeductionAccount] = useState("");
  const [deductionAmount, setDeductionAmount] = useState(0);
  const [deductionType, setDeductionType] = useState("Rp");
  const [advanceChecked, setAdvanceChecked] = useState(false);
  const [advanceAccount, setAdvanceAccount] = useState("");
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const [remainingBill, setRemainingBill] = useState(0);

  const [products, setProducts] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [taxAmount, setTaxAmount] = useState(0);

  const [isDiscountAbove, setIsDiscountAbove] = useState(true);
  const [discountRow, setDiscountRow] = useState(0); // Default to Rp
  const [discountType, setDiscountType] = useState('%'); // Default to Rp
  const [discountValue, setDiscountValue] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);

  const [isFormatTransactionOpen, setFormatTransactionOpen] = useState(false);

  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);

  const [error, setError] = useState(null);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_SALES = "api/erpppsu/sales";
  const PATH_CONTACT_CUSTOMER = "api/erpppsu/contact/customer";
  const PATH_TERMS_PAYMENT = "api/erpppsu/account/termspayment";
  const PATH_WAREHOUSE = "api/erpppsu/warehouse/option";
  const PATH_ACCOUNT_CASH_BANK = "api/erpppsu/account/cashbank";

  const fetchData = async (URL) => {
    try {
      const response = await axios.get(URL);
      return response.data; // Return only the data from the response
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.log(err);
    }
  };

  const handleDiscountChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setDiscountValue(value);
  };

  const calculateRemainingBill = (deduction, advance) => {
    const totalBill = total;
    const remaining = totalBill - deduction - advance;
    setRemainingBill(remaining > 0 ? remaining : 0);
  };

  useEffect(() => {
    if (!advanceChecked) {
      setAdvanceAmount(0);
    }

    if (!deductionChecked) {
      setDeductionAmount(0);
    }

    calculateRemainingBill(deductionAmount, advanceAmount);
  }, [advanceChecked, advanceAmount, deductionChecked, deductionAmount])

  useEffect(() => {
    if (type) {
      setTypeSale(type);
    }
  }, [type]);

  useEffect(() => {
    if (id) {
      fetchData(`${BASE_URL}${PATH_SALES}/detail?id=${id}`).then((data) => {
        setDetailData(data)
      });

      fetchData(`${BASE_URL}${PATH_SALES}/items?id=${id}`).then((data) => {
        setItemData(data)
      });
    }
  }, [id]);

  useEffect(() => {

    if (detailData != null) {
      setInitialValues(prev => ({
        ...prev,
        customer: detailData?.customer_id || '',
        address : detailData?.address || '',
        email : detailData?.customer_email || '',
        date : detailData?.date || '',
        due_date : detailData?.due_date || '',
        no_transaction : detailData?.no_transaction || ''
      }));      
    }

    
  }, [detailData]);

  useEffect(() => {
    fetchData(`${BASE_URL}${PATH_CONTACT_CUSTOMER}`,).then((data) => {
      setContactCustomer(data);
    });

    fetchData(`${BASE_URL}${PATH_TERMS_PAYMENT}`,).then((data) => {
      setTermsPayment(data);
    });

    fetchData(`${BASE_URL}${PATH_WAREHOUSE}`,).then((data) => {
      setWarehouse(data);
    });

    fetchData(`${BASE_URL}${PATH_ACCOUNT_CASH_BANK}?types=cash_and_bank,income`,).then((data) => {
      setCashBank(data);
    });

    fetchData(`${BASE_URL}${PATH_ACCOUNT_CASH_BANK}?types=income,cash_and_bank`,).then((data) => {
      setCashBankPayment(data);
    });
  }, []);

  useEffect(() => {
    setTaxes(groupByTax(products));
  }, [products, isDiscountAbove]);

  useEffect(() => {
    const discountAmount =
      discountType === "%"
        ? ((subtotal - discountRow) * discountValue) / 100
        : discountValue;
    const totalTaxes = taxes.reduce((acc, tax) => acc + (tax.totalTax || 0), 0);
    const finalTotal = subtotal - discountRow - discountAmount + totalTaxes;

    setTaxAmount(totalTaxes);
    setDiscountAmount(discountAmount);
    setTotal(finalTotal);
  }, [taxes, discountRow, discountType, discountValue]);

  const getLabelType = (type) => {
    switch (type) {
      case 'invoice':
        return "Penagihan";
      case 'order':
        return "Pemesanan";
      case 'quote':
        return "Penawaran";
      default:
        return type;
    }
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        id,
        ...values,
        type: typeSale,
        subtotal: subtotal,
        amount: total,
        tax_amount: taxAmount,
        advanceAccount,
        advanceAmount,
        deductionAccount,
        deductionAmount,
        selectedTags,
        products,
      };

      await axios.post(`${BASE_URL}${PATH_SALES}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        }
      });

      navigate('/activity-erpppsu/sales');
    } catch (error) {
      alert(error.response.data);
      console.error('Error submitting form:', error);
    } finally {
      setSubmitting(false);
    }
  };

  // Validation schema (using Yup)
  const validationSchema = Yup.object({
    // description: Yup.string().required('Deskripsi diperlukan'),
    // amount: Yup.number().required('Jumlah diperlukan').positive('Jumlah harus lebih besar dari nol'),
  });

  const options = [
    { value: 'invoice', label: 'Penagihan Penjualan' },
    { value: 'order', label: 'Pemesanan Penjualan' },
    { value: 'quote', label: 'Penawaran Penjualan' }
  ];

  const [selectedTags, setSelectedTags] = useState([]);

  const handleTagsChange = (tags) => {
    setSelectedTags(tags);
  };

  const handleProductUpdate = (data) => {
    setProducts(data);
  };

  const groupByTax = (items) => {
    const grouped = items.reduce((acc, item) => {
      const tax_name = item.tax_name;
      if (!acc[tax_name]) {
        acc[tax_name] = {
          tax_id: item.tax_id,
          taxRate: item.tax,
          tax_name: item.tax_name,
          items: [],
          totalTaxableAmount: 0,
          totalTax: 0,
        };
      }

      const taxableAmount = item.quantity * item.unit_price;
      const discountRowAmount = taxableAmount * item.discount / 100;

      const discountAmount =
        discountType === "%"
          ? ((taxableAmount - discountRowAmount) * discountValue) / 100
          : discountValue;
      const tax = (taxableAmount * item.tax) / 100;
      const tax2 = (taxableAmount - discountRowAmount - discountAmount) * item.tax / 100;

      // Update the group
      acc[tax_name].items.push(item);
      acc[tax_name].totalTaxableAmount += taxableAmount;
      acc[tax_name].totalTax += isDiscountAbove ? tax : tax2;

      return acc;
    }, {});

    // Convert object to array
    return Object.values(grouped);
  };

  return (
    <div>
      <div className='flex items-center justify-between px-5'>
        <h2 className="text-2xl font-bold mb-4">
          {id ? `Edit ${getLabelType(typeSale)} Penjualan` : `Tambah ${getLabelType(typeSale)} Penjualan`}
        </h2>

        <div className='flex items-center'>
          <ButtonOptionGroup
            label={"Buat Penjualan Baru"}
            options={options}
            selectedValue={typeSale}
            onChange={(value) => {
              setTypeSale(value)
            }}
          />
        </div>
      </div>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ values, handleChange, setFieldValue, isSubmitting }) => (
          <Form>
            <div className="container m-auto p-4">
              <div className="container m-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">

                <ContactComponent
                  defaultValue={detailData?.customer_id}
                  contact={contactCustomer}
                  onChange={(value) => {
                    setFieldValue(`customer`, value);
                  }} />

                <div></div>

                <div className="p-3">
                  <h1>Total Rp{total.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                </div>

                <div className="p-3">
                  <label htmlFor="address" className="mb-1 text-sm font-semibold">Alamat</label>
                  <Field
                    as="textarea"
                    name="address"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="address" component="p" className="text-red-500 text-xs mt-1" />
                </div>

                <div className="">
                  <div className="p-3">
                    <label htmlFor="date" className="mb-1 text-sm font-semibold">Tgl. Transaksi</label>
                    <Field
                      type='date'
                      name="date"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                    <ErrorMessage name="date" component="p" className="text-red-500 text-xs mt-1" />
                  </div>

                  <div className="p-3">
                    <label htmlFor="due_date" className="mb-1 text-sm font-semibold">Tgl. Jatuh Tempo</label>
                    <Field
                      type='date'
                      name="due_date"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                    <ErrorMessage name="due_date" component="p" className="text-red-500 text-xs mt-1" />
                  </div>

                  <div className="p-3">
                    <label htmlFor="payment_terms" className="mb-1 text-sm font-semibold">Syarat Pembayaran</label>
                    <Field
                      as="select"
                      name="payment_terms"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                      onChange={(e) => setFieldValue(`payment_terms`, e.target.value)}
                    >
                      <option value="">Pilih Syarat Pembayaran</option>
                      {termsPayment.map((account) => (
                        <option key={account.id} value={account.id}>
                          {account.name}
                        </option>
                      ))}
                    </Field>
                  </div>
                </div>

                <div className="">
                  <div className="p-3">
                    <FormatTransaction
                      show={isFormatTransactionOpen}
                      onClose={() => setFormatTransactionOpen(false)}
                      apply={(value) => {
                        setFieldValue('no_transaction', value);
                      }} />

                    <label htmlFor="no_transaction" className="mb-1 text-sm font-semibold">
                      No. Transaksi&nbsp;
                      <button type="button" onClick={() => setFormatTransactionOpen(true)}>
                        <FontAwesomeIcon icon={faGears} />
                      </button>
                    </label>
                    <Field
                      name="no_transaction"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                    <ErrorMessage name="no_transaction" component="p" className="text-red-500 text-xs mt-1" />
                  </div>

                  <div className="p-3">
                    <label htmlFor="no_customer_refference" className="mb-1 text-sm font-semibold">No. Referensi</label>
                    <Field
                      name="no_customer_refference"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                    <ErrorMessage name="no_customer_refference" component="p" className="text-red-500 text-xs mt-1" />
                  </div>

                  <div className="p-3">
                    <label htmlFor="warehouse" className="mb-1 text-sm font-semibold">Gudang</label>
                    <Field
                      as="select"
                      name="warehouse"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                      onChange={(e) => setFieldValue(`warehouse`, e.target.value)}
                    >
                      <option value="">Pilih Gudang</option>
                      {warehouse.map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.name}
                        </option>
                      ))}
                    </Field>
                  </div>
                </div>

                <div className="p-3">
                  <MultiTagInput name="tags" options={['Sales', 'PPSU', 'PRSU', 'KMPSUMUT', 'TIKET']} onTagsChange={handleTagsChange} />
                </div>
              </div>

              <ProductComponent
                type='sale'
                items={itemData}
                onProductUpdated={handleProductUpdate}
                onSubtotalUpdated={(value) => {
                  setSubtotal(value)
                }}
                onProductDiscount={(value) => {
                  setDiscountRow(value);
                }} />

              <div className="container m-auto grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                <div className="">
                  <div className="p-3">
                    <label htmlFor="notes" className="mb-1 text-sm font-semibold">Pesan</label>
                    <Field
                      as="textarea"
                      name="notes"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                  </div>
                  <div className="p-3">
                    <label htmlFor="memo" className="mb-1 text-sm font-semibold">Memo</label>
                    <Field
                      as="textarea"
                      name="memo"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                  </div>
                </div>
                <div></div>

                <div className='col-span-2'>
                  <div className="max-w-xl mx-auto mt-8 rounded-lg px-5">
                    <div className="flex items-center justify-between mb-6">
                      <h1 className="text-lg font-semibold">Subtotal</h1>
                      <h1 className="text-lg font-semibold">Rp{subtotal.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                    </div>

                    <DiscountComponent
                      isDiscountAbove={isDiscountAbove}
                      onPositionChanged={(val) => {
                        setIsDiscountAbove(val);
                      }}
                      onValueChanged={handleDiscountChange}
                      onTypeChanged={(e) => setDiscountType(e.target.value)}
                      discountType={discountType}
                      discountValue={discountValue}
                      discountAmount={discountAmount}
                      discountRowAmount={discountRow}
                      componentTax={taxes?.map((data) => (
                        <div className="flex items-center justify-between">
                          <p>{data.tax_name}</p>
                          <p>Rp{data.totalTax.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</p>
                        </div>
                      ))} />

                    <div className="border-t-2 border-dashed border-gray-300 my-6"></div>
                    <div className="flex items-center justify-between">
                      <h1 className="text-lg font-semibold">Total</h1>
                      <h1 className="text-lg font-semibold">Rp{total.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                    </div>
                  </div>
                  <div className="max-w-xl mx-auto mt-8 rounded-lg px-5">
                    {/* Deduction Section */}
                    <div className="flex items-center space-x-2 mb-4 px-4">
                      <input
                        type="checkbox"
                        checked={deductionChecked}
                        onChange={() => setDeductionChecked(!deductionChecked)}
                        className="h-5 w-5 text-blue-500 focus:ring-blue-400 border-gray-300 rounded"
                      />
                      <label className="text-gray-700 font-medium">Pemotongan</label>
                    </div>
                    {deductionChecked && (
                      <div className="flex justify-between space-x-2 px-4">
                        <div className="flex items-center border border-gray-300 rounded-md bg-white focus-within:ring-2 focus-within:ring-blue-400">
                          <select
                            value={deductionType}
                            onChange={(e) => setDeductionType(e.target.value)}
                            className="bg-transparent text-gray-700 p-2 focus:outline-none"
                          >
                            {/* <option value="%">%</option> */}
                            <option value="Rp">Rp</option>
                          </select>
                          <input
                            type="number"
                            value={deductionAmount}
                            onChange={(e) => setDeductionAmount(parseFloat(e.target.value))}

                            className="flex-1 p-2 bg-transparent focus:outline-none"
                          />
                        </div>
                        <p>Rp{deductionAmount.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</p>
                      </div>
                    )}
                    {deductionChecked && (
                      <div className="flex justify-between mb-4 p-4">
                        <div className="flex items-center">
                          Potong Dari-
                        </div>
                        <div className="flex items-center w-2/4">
                          <InputOption
                            label="Pilih Produk"
                            data={cashbank}
                            placeholder="Ketik disini"
                            onChange={(value) => setDeductionAccount(value)}
                            returnKey="code"
                          />
                        </div>
                      </div>
                    )}

                    {/* Advance Section */}
                    <div className="flex items-center space-x-2 p-4">
                      <input
                        type="checkbox"
                        checked={advanceChecked}
                        onChange={() => setAdvanceChecked(!advanceChecked)}
                        className="h-5 w-5 text-blue-500 focus:ring-blue-400 border-gray-300 rounded"
                      />
                      <label className="text-gray-700 font-medium">Uang muka</label>
                    </div>
                    {advanceChecked && (
                      <div className="flex justify-between space-x-2 px-4">
                        <div className="flex items-center border border-gray-300 rounded-md bg-white focus-within:ring-2 focus-within:ring-blue-400">
                          <select
                            className="bg-transparent text-gray-700 p-2 focus:outline-none">
                            <option value="Rp">Rp</option>
                          </select>
                          <input
                            type="number"
                            value={advanceAmount}
                            onChange={(e) => setAdvanceAmount(parseFloat(e.target.value))}
                            className="flex-1 p-2 bg-transparent focus:outline-none"
                          />
                        </div>
                        <p>Rp{advanceAmount.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</p>
                      </div>
                    )}
                    {advanceChecked && (
                      <div className="flex justify-between px-4">
                        <div className="flex items-center">
                          Setor Ke-
                        </div>
                        <div className="flex items-center w-2/4">
                          <InputOption
                            label="Pilih Produk"
                            data={cashbankPayment}
                            placeholder="Ketik disini"
                            onChange={(value) => setAdvanceAccount(value)}
                            returnKey="code"
                          />
                        </div>
                      </div>
                    )}

                    {/* Dashed Divider */}
                    <div className="border-t-2 border-dashed border-gray-300 my-6"></div>

                    {/* Remaining Bill */}
                    <div className="flex items-center justify-between">
                      <h1 className="text-lg font-semibold">Sisa tagihan</h1>
                      <h1 className="text-lg font-semibold">
                        Rp{remainingBill.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                    </div>

                    <div className="flex items-center justify-end mt-5">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                          }`}
                      >
                        {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div >
  );
};

export default EntrySales;
